<template>
  <div>
     <el-dialog title="查看图片" :visible.sync="imgDetailsShow" width="90%">
      <div class="show-img-wrap" v-if="detailsImg">
        <img
          style="max-width: 500px; margin-right: 10px"
          :src="detailsImg"
        />
      </div>
    </el-dialog>
    <div v-if="visible">
      <el-dialog
        title="新增图片"
        :visible.sync="visible"
        width="60%"
        @close="close"
      >
        <div class="title-wrap d-w">
          <div class="left-text">图片</div>
          <div>
            <el-upload
              :on-success="handleAvatarSuccess"
              :data="uploadData"
              class="a-u-d"
              :action="action"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="ava" />
              <i v-else class="el-icon-plus a-u-d-icon"></i>
            </el-upload>
          </div>
        </div>
        <div class="e-b-w">
          <el-button type="primary" @click="handleAddSure" :loading="subLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="a-t">
      <el-button @click="handleAdd" type="primary">
        新增
      </el-button>
    </div>
    <LoadingNoDialog :loading="loading">
      <el-table
        class="clear-fix"
        border
        :empty-text="emptyText"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column label="名称" prop="name"> </el-table-column>

        <el-table-column prop="payCode" label="图片">
          <template slot-scope="scope">
            <img :src="scope.row.imgUrl" style="height: 140px" />
          </template>
        </el-table-column>

        <el-table-column prop="createdAt" label="创建时间"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="230px">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="(e) => show(scope.row)"
              >查看</el-button
            >
            <el-button type="info" size="small" @click="(e) => edit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="(e) => deleteRow(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </LoadingNoDialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
import OssUpload from "../../common/OssUpload";
let ossResultProxy = null;
export default {
  name: "Role",
  data() {
    return {
      emptyText: "暂无数据",
      size: 10,
      page: 1,
      tableData: [],
      total: 0,
      loading: false,
      tagImgDialog: false,

      visible: false,
      isAdd: true,
      subLoading: false,
      uploadData: {},
      action: "",
      imageUrl: "",
      picName: "",
      id:'',
      imgDetailsShow:false,
      detailsImg:null
    };
  },
  components: {
    ElButton,
    LoadingNoDialog,
  },
  mounted() {
    this.getList();
  },
  methods: {
    show(row) {
      this.imgDetailsShow=true
      this.detailsImg=row.imgUrl
    },
    deleteRow(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: "删除中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let r = await axios.delete("/admin/delete-banner", {
          params: { id: row.id },
        });
        loading.close();
        if (r.code == 0) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
        } else {
          this.$message.warning("删除失败");
        }
        this.getList();
      });
    },
    edit(row) {
      this.imageUrl = row.imgUrl;
      ossResultProxy = { objectKey: row.img };
      this.picName = row.name;
      this.visible = true;
      this.isAdd = false;
      this.id=row.id
    },
    async beforeAvatarUpload(e) {
      this.picName = e.name;
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let ossUpload = new OssUpload();
      let ossResult = await ossUpload.getElOssPolicy(2);
      this.action = ossResult.host;
      this.uploadData = ossResult.uploadData;
      ossResultProxy = ossResult;
      loading.close();
      return true;
    },
    handleAdd() {
      this.isAdd=true
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    async handleAddSure() {
      this.subLoading = true;
      if (this.isAdd) {
        let r = await axios.post("/admin/banner-add", {
          img: ossResultProxy.objectKey,
          name: this.picName,
        });
        this.imageUrl = "";
        if (r.code == 0) {
          this.$message.success("新增成功");
        } else {
          this.$message.warning("新增失败");
        }
      } else {
        let r = await axios.post("/admin/edit-banner", {
          id:this.id,
          img: ossResultProxy.objectKey,
          name: this.picName,
        });
        this.imageUrl = "";
        if (r.code == 0) {
          this.$message.success("修改成功");
        } else {
          this.$message.warning("修改失败");
        }
      }
      this.visible = false;
      this.subLoading = false;
      this.getList();
    },
    handleAvatarSuccess() {
      if (ossResultProxy != null) {
        this.imageUrl = ossResultProxy.url;
      }
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },

    async getList() {
      this.loading = true;
      let r = await axios.get("/admin/banner-lists", {
        page: this.page,
        size: this.size,
      });
      if (r.code == 51) {
        this.loading = false;
        this.emptyText = "无权限";
        return;
      }
      this.tableData = r.data.rows.map((item) =>
        Object.assign(item, {
          createdAt: moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        })
      );

      this.total = r.data.count;
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.submit-wrap {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}
.title-wrap {
  display: flex;
  align-items: center;
}
.left-text {
  width: 60px;
  font-size: 18px;
  display: flex;
  justify-content: center;
}
.d-w {
  margin: 10px 0px;
}
.a-u-d {
  border: 1px dashed #ddd;
}
.a-u-d .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid #ddd;
}

.a-u-d .el-upload:hover {
  border-color: #409eff;
}

.a-u-d-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.ava {
  width: 300px;
  height: 100px;
  display: block;
}
.s-w {
  display: flex;
  align-items: center;
  margin-left: 80px;
}
.m-w {
  display: flex;
  align-content: center;
}
.e-b-w {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}
.a-t {
  margin-bottom: 10px;
}
.show-img-wrap {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/Banner.vue